import { Injectable, EventEmitter, Inject, isDevMode } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BootConstants } from '../boot.constants';
import { IChangePassword } from '../interfaces/IChangePassword';
import { map } from 'rxjs/operators';
import { BaseRepository } from './base.repository';
import { IDepositListFilter } from '../interfaces/IDepositListFilter';
import { IPlantToDepotTour } from '../interfaces/ITour';
import { IPlantToDepotDetails } from '../interfaces/IPlantToDepotDetails';


@Injectable()
export class TourRepository extends BaseRepository {
    setDeliveryMessage(tourId: string, deliveryMessageId: number): Observable<null> {
        return this.mapPut("tours/setDeliveryMessage", {tourId, deliveryMessageId});
    }

    constructor(tokenHttp: TokenHttp) { 
        super(tokenHttp);
    }

    public plantToDepotList(filter: IDepositListFilter): Observable<IPlantToDepotTour[]> {
        return this.mapGet("tours/plantToDepot/list", filter);
    }

    public plantToDepotDetails(id: string): Observable<IPlantToDepotDetails> {
        return this.mapGet("tours/plantToDepot/" + id + "/details");
    }

    public plantToDepotApprove(id: string, shouldAutoApproveInManager: boolean): Observable<IPlantToDepotDetails> {
        return this.mapPut("tours/plantToDepot/" + id + "/approve", { shouldAutoApproveInManager });
    }
    
    public plantToDepotDelete(id: string): Observable<IPlantToDepotDetails> {
        return this.mapPut("tours/plantToDepot/" + id + "/delete");
    }

    public plantToDepotFix(id: string): Observable<IPlantToDepotDetails> {
        return this.mapPut("tours/plantToDepot/" + id + "/fix");
    }

    public plantToDepotCreateTilfoersel(id: string): Observable<null> {
        return this.mapPut("tours/plantToDepot/" + id + "/tilfoersel");
    }

    public plantToDepotComplete(id: string, body: { completedTime: string, comment: string }): Observable<null> {
        return this.mapPut("tours/plantToDepot/" + id + "/complete", body);
    }

    public downloadAsExcel(filter: IDepositListFilter) {
        return this.mapGet("tours/plantToDepot/excel", filter);
    }
}